import * as Actions from '../actions';

const initialState = {
	homeData: null,
	loadingHomeData: true,

	categoryData: null,
	loadingCategoryData: true,

	productDetails: null,
	loadingProductDetails: true
};

const homeReducer = function(state = initialState, action) {
	switch (action.type) {
		case Actions.GET_HOME_DATA: {
			return {
				...state,
				loadingHomeData: false,
				homeData: action.payload
			};
		}
		case Actions.SET_HOME_DATA_LOADER: {
			return {
				...state,
				loadingHomeData: action.payload
			};
		}

		case Actions.GET_CATEGORY_DATA: {
			return {
				...state,
				loadingCategoryData: false,
				categoryData: action.payload
			};
		}
		case Actions.SET_CATEGORY_DATA_LOADER: {
			return {
				...state,
				loadingCategoryData: action.payload
			};
		}

		case Actions.GET_PRODUCT_DETAILS: {
			return {
				...state,
				loadingProductDetails: false,
				productDetails: action.payload
			};
		}
		case Actions.SET_PRODUCT_DETAILS_LOADER: {
			return {
				...state,
				loadingProductDetails: action.payload
			};
		}

		default: {
			return state;
		}
	}
};
export default homeReducer;
